import { Theme, FilledInput, FilledInputProps, FormControl, FormControlProps, FormHelperText, FormHelperTextProps, InputLabelProps, FilledTextFieldProps, FormLabel } from '@mui/material';
import {makeStyles} from '@mui/styles';

type StyleProps = {
  elevation?: number;
}

const useStyles = makeStyles((theme : Theme) => ({
  root: {
    
  },
  label: {
    marginBottom: theme.spacing(1),
  },
  input: {
    boxShadow: ({elevation} : StyleProps) => theme.shadows[elevation]
  },
  helper: {

  },
}), {name: 'ElevatedInput'});

export type ElevatedInputProps = FormControlProps
                               & FormHelperTextProps
                               & FilledInputProps
                               & InputLabelProps
                               & Partial<FilledTextFieldProps>
                               & StyleProps;

const ElevatedInput = ({
  autoComplete,
  autoFocus,
  color,
  defaultValue,
  disableUnderline,
  disabled,
  elevation = 1,
  endAdornment,
  error,
  filled,
  focused,
  fullWidth,
  FormHelperTextProps,
  helperText,
  hiddenLabel,
  inputComponent,
  inputProps,
  InputProps,
  inputRef,
  InputLabelProps,
  label,
  margin,
  maxRows,
  multiline,
  name,
  onChange,
  placeholder,
  readOnly,
  required,
  rows,
  type,
  value,
  size,
  sx
} : ElevatedInputProps) => {

  const formControlProps = {
    color,
    disabled,
    error: !!error,
    focused,
    fullWidth,
    hiddenLabel,
    margin,
    required,
    size,
    sx
  };
  const inputLabelProps = {
    color,
    disabled,
    error:
    !!error,
    filled,
    focused,
    required,
    ...InputLabelProps
  };
  const filledInputProps = {
    autoComplete,
    autoFocus,
    color,
    defaultValue,
    disableUnderline,
    disabled,
    endAdornment,
    error: !!error,
    hiddenLabel,
    fullWidth,
    inputComponent,
    inputProps,
    inputRef,
    margin,
    maxRows,
    multiline,
    name,
    onChange,
    placeholder,
    readOnly,
    required,
    rows,
    type,
    value,
    size,
    ...InputProps
  };
  const formHelperTextProps = {
    disabled,
    error: !!error,
    filled,
    focused,
    margin,
    required,
    ...FormHelperTextProps
  };

  const classes = useStyles({elevation});

  return (
    <FormControl className={classes.root} {...formControlProps}>

      {label && (
        <FormLabel className={classes.label} id={`${name}-label`} aria-label={name} htmlFor={name} {...inputLabelProps}>
          {label}
        </FormLabel>
      )}
      
      <FilledInput
        className={classes.input}
        id={name}
        aria-labelledby={`${name}-label`}
        aria-describedby={`${name}-helper-text`}
        {...filledInputProps}
      />
      
      {error && (
        <FormHelperText className={classes.helper} id={`${name}-helper-text`} {...formHelperTextProps}>
          {error || helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default ElevatedInput;